import { colors, fonts, frames, glyphs } from "../../../../Styles";
import { CheckBox, CheckStyles, NewInput, PageHeader, Setting } from "../../../../Components";
import { LoadingSpinner } from "../../../../Services/wrapper";
import NewButton from "../../../../Components/BaseComponents/newButton";
import { ButtonTypes, NewFieldStyles } from "../../../../Definitions";
import { useState } from "react";
import { CREATE_COMPANY, CreateCompanyArgs, CreateCompanyInput, CreateCompanyResponse } from "../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/createCompany";
import { useMutation } from "@apollo/client";

const defaultFieldOverrides = {
	fieldStyle: NewFieldStyles.greyTertiary
}

export default function CreateCompany() {
	const [companyInput, setCompanyInput] = useState<CreateCompanyInput>({ domain: "", name: "" });

	const [createCompany, { data, loading, error, reset: resetCreateCompanyState }] = useMutation<CreateCompanyResponse, CreateCompanyArgs>(CREATE_COMPANY, {
		fetchPolicy: "network-only"
	});

	const isSuccess: boolean | undefined = data?.company.create.success;

	function setCompanyInputState<K extends keyof CreateCompanyInput>(key: K, value: CreateCompanyInput[K]) {
		setCompanyInput(prev => ({ ...prev, [key]: value }));
	}

	function isDomainValid(domain: string): boolean {
		const domainRegex = /^[a-z_]{1,12}$/;
		return domainRegex.test(domain);
	}

	function handleResetState() {
		setCompanyInput({ domain: "", name: "" });
		resetCreateCompanyState();
	}

	return (
		<frames.Page_inner>
				<PageHeader topHeader='Create Company' subHeader='Overview' />
			<frames._page_inner_content>
				<Setting
					startEnhancer={glyphs.FarmInfo({ size: "25px" })}
					header={"company"}
					content={
						<div style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "left",
							gap: "10px",
							maxHeight: "400px",
							overflowY: "auto",
						}}>
							{!isSuccess &&
								<>
									<div>
										<NewInput
											fieldOverrides={defaultFieldOverrides}
											header={"domain"}
											onChange={(e) => setCompanyInputState("domain", e)}
											isBlocked={!isDomainValid(companyInput.domain)}
										/>
										{!isDomainValid(companyInput.domain) &&
											<p style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.systemRed }}>Lowercase letters and "_" only, max 12 characters</p>
										}
									</div>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"name"}
										isRequired
										onChange={(e) => setCompanyInputState("name", e)}
									/>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"city"}
										onChange={(e) => setCompanyInputState("city", e)}
									/>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"street"}
										onChange={(e) => setCompanyInputState("street", e)}
									/>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"phone"}
										onChange={(e) => setCompanyInputState("phone", e)}
									/>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"vat"}
										onChange={(e) => setCompanyInputState("vat", e)}
									/>
									<NewInput
										fieldOverrides={defaultFieldOverrides}
										header={"email"}
										onChange={(e) => setCompanyInputState("email", e)}
									/>
									<CheckBox
										text={"LEGACY"}
										checkStyle={CheckStyles.grey}
										onChange={(e) => setCompanyInputState("legacy", e)}
										isChecked={companyInput.legacy}
									/>
									{loading &&
										<div style={{ width: "100%", marginTop: "20px" }}>
											<LoadingSpinner />
										</div>
									}
									{(error || isSuccess === false) &&
										<div style={{ width: "100%", marginTop: "20px" }}>
											<p style={{ ...fonts.fontSize3, ...fonts.paragraph, color: colors.systemRed, maxWidth: "500px" }}>ERROR: failed to create company</p>
										</div>
									}
									{!loading &&
										<div style={{ width: "100%" }}>
											<NewButton
												buttonType={ButtonTypes.primaryButton}
												content={"Create"}
												overrides={{
													baseStyles: { backgroundColor: colors.greyPrimary, marginTop: "30px", },
													hoverStyles: { backgroundColor: colors.greySecondary },
												}}
												onClick={() => {
													createCompany({ variables: { input: companyInput } })
												}}
												disabled={!isDomainValid(companyInput.domain) || !companyInput.name}
											/>
										</div>
									}
								</>
							}
							{!loading && !error && isSuccess &&
								<>
									<div style={{ width: "100%" }}>
										<p style={{ ...fonts.fontSize3, ...fonts.paragraph, color: colors.systemGreen, maxWidth: "500px" }}>Succesfully created company</p>
									</div>
									<div style={{ width: "100%", display: "flex", marginTop: "20px" }}>
										<NewButton
											buttonType={ButtonTypes.primaryButton}
											content={"Create new company"}
											overrides={{
												baseStyles: { backgroundColor: colors.greyPrimary },
												hoverStyles: { backgroundColor: colors.greySecondary },
											}}
											onClick={() => {
												handleResetState();
											}}
										/>
									</div>

								</>
							}
						</div>
					}
				/>
			</frames._page_inner_content>
		</frames.Page_inner>
	)
}